module.exports = __webpack_public_path__ + "media/images/app/about/tanya-f897a9f21d4cd6a5c77d203e984009ff.webp";